var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/pages/profile_page.tsx";
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Redirect, useHistory } from 'react-router-dom';
import { Column, Layout, Tabs, Widget } from 'soapbox/components/ui';
import Header from 'soapbox/features/account/components/header';
import LinkFooter from 'soapbox/features/ui/components/link_footer';
import BundleContainer from 'soapbox/features/ui/containers/bundle_container';
import { WhoToFollowPanel, ProfileInfoPanel, ProfileFieldsPanel, SignUpPanel, PinnedAccountsPanel } from 'soapbox/features/ui/util/async-components';
import { useAppSelector, useFeatures, useSoapboxConfig } from 'soapbox/hooks';
import { findAccountByUsername, makeGetAccount } from 'soapbox/selectors';
import { getAcct, isLocal } from 'soapbox/utils/accounts';
const getAccount = makeGetAccount();

/** Page to display a user's profile. */
const ProfilePage = ({
  params,
  children
}) => {
  const history = useHistory();
  const username = params?.username || '';
  const account = useAppSelector(state => {
    if (username) {
      const account = findAccountByUsername(state, username);
      if (account) {
        return getAccount(state, account.id) || undefined;
      }
    }
  });
  const me = useAppSelector(state => state.me);
  const features = useFeatures();
  const {
    displayFqn
  } = useSoapboxConfig();

  // Fix case of username
  if (account && account.acct !== username) {
    return /*#__PURE__*/React.createElement(Redirect, {
      to: `/@${account.acct}`,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 49,
        columnNumber: 12
      }
    });
  }
  const tabItems = [{
    text: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "account.posts",
      defaultMessage: "Posts",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 54,
        columnNumber: 13
      }
    }),
    to: `/@${username}`,
    name: 'profile'
  }, {
    text: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "account.posts_with_replies",
      defaultMessage: "Posts and replies",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 59,
        columnNumber: 13
      }
    }),
    to: `/@${username}/with_replies`,
    name: 'replies'
  }, {
    text: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "account.media",
      defaultMessage: "Media",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 64,
        columnNumber: 13
      }
    }),
    to: `/@${username}/media`,
    name: 'media'
  }, {
    text: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "account.about",
      defaultMessage: "About",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 69,
        columnNumber: 13
      }
    }),
    to: `/@${username}/about`,
    name: 'about'
  }];
  let activeItem;
  const pathname = history.location.pathname.replace(`@${username}/`, '');
  if (pathname.endsWith('/with_replies')) {
    activeItem = 'replies';
  } else if (pathname.endsWith('/media')) {
    activeItem = 'media';
  } else if (pathname.endsWith('/about')) {
    activeItem = 'about';
  } else {
    activeItem = 'profile';
  }
  const showTabs = !['/following', '/followers', '/pins'].some(path => pathname.endsWith(path));
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Layout.Main, {
    className: "",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 91,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Column, {
    label: account ? `@${getAcct(account, displayFqn)}` : '',
    withHeader: false,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 92,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "space-y-4",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 93,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(Header, {
    account: account,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 94,
      columnNumber: 13
    }
  }), /*#__PURE__*/React.createElement(BundleContainer, {
    fetchComponent: ProfileInfoPanel,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 96,
      columnNumber: 13
    }
  }, Component => /*#__PURE__*/React.createElement(Component, {
    username: username,
    account: account,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 97,
      columnNumber: 29
    }
  })), account && showTabs && /*#__PURE__*/React.createElement(Tabs, {
    items: tabItems,
    activeItem: activeItem,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 101,
      columnNumber: 15
    }
  }), children))), /*#__PURE__*/React.createElement(Layout.Aside, {
    className: "",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 109,
      columnNumber: 7
    }
  }, account && !account.fields.isEmpty() && /*#__PURE__*/React.createElement(Widget, {
    title: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "profile_fields_panel.title",
      defaultMessage: "Profile fields",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 111,
        columnNumber: 26
      }
    }),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 111,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(BundleContainer, {
    fetchComponent: ProfileFieldsPanel,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 112,
      columnNumber: 13
    }
  }, Component => /*#__PURE__*/React.createElement(Component, {
    account: account,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 113,
      columnNumber: 29
    }
  }))), !me && /*#__PURE__*/React.createElement(BundleContainer, {
    fetchComponent: SignUpPanel,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 118,
      columnNumber: 11
    }
  }, Component => /*#__PURE__*/React.createElement(Component, {
    key: "sign-up-panel",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 119,
      columnNumber: 27
    }
  })), features.accountEndorsements && account && isLocal(account) && me ? /*#__PURE__*/React.createElement(BundleContainer, {
    fetchComponent: PinnedAccountsPanel,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 123,
      columnNumber: 11
    }
  }, Component => /*#__PURE__*/React.createElement(Component, {
    account: account,
    limit: 5,
    key: "pinned-accounts-panel",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 124,
      columnNumber: 27
    }
  })) : features.suggestions && /*#__PURE__*/React.createElement(BundleContainer, {
    fetchComponent: WhoToFollowPanel,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 127,
      columnNumber: 11
    }
  }, Component => /*#__PURE__*/React.createElement(Component, {
    limit: 5,
    key: "wtf-panel",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 128,
      columnNumber: 27
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "grow",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 131,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement(LinkFooter, {
    key: "link-footer",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 132,
      columnNumber: 9
    }
  })));
};
export default ProfilePage;